import React from 'react';

// DOS-8: retire / restore affordances for a pen card. Retired pens show a
// Restore button; every other status shows a Retire button. Presentational —
// the parent owns the confirmation dialog and the API calls.
interface PenActionsProps {
  status?: string;
  onRetire: () => void;
  onRestore: () => void;
}

const PenActions: React.FC<PenActionsProps> = ({ status, onRetire, onRestore }) => {
  const stop = (handler: () => void) => (e: React.MouseEvent) => {
    e.stopPropagation();
    handler();
  };

  if (status === 'retired') {
    return (
      <button
        type="button"
        onClick={stop(onRestore)}
        className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs transition-colors"
        title="Restore pen to active"
        aria-label="Restore pen"
        data-testid="pen-restore-button"
      >
        ♻️
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={stop(onRetire)}
      className="bg-stone-500 hover:bg-stone-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs transition-colors"
      title="Retire pen (archive — keeps all history)"
      aria-label="Retire pen"
      data-testid="pen-retire-button"
    >
      📦
    </button>
  );
};

export default PenActions;
